
import { Tabs, Grid, Button, Row } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";

import { useLocation, useNavigate } from "react-router-dom";

const { useBreakpoint } = Grid;
import { accessChecker } from "../../lib/functions";
import AttendanceEntry from "../AttendanceEntry";
import AttendanceOverview from "../AttendanceOverview";
import ClockInOutTab from "./ClockInOutTab";

const AttendanceTabs = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);
  const activeTab = params.get("tab") || "entry";
  const screens = useBreakpoint();

  const menuData = [
    {
      label: "Mark Attendance",
      key: "overview",
      value: "attendance_overview",
      children: (
        <>
          <AttendanceOverview />
        </>
      ),
    },
    {
      label: "Attendance Entry",
      key: "attendance entry",
      value: "attendance_entry",
      children: (
        <>
          <AttendanceEntry />
        </>
      ),
    },
   { label: "Clock In / Out", key: "clockinout", value: "attendance_overview", children: <ClockInOutTab /> }
  ];

  const filteredMenuData = menuData.filter((menuItem) => accessChecker(menuItem.value));
  return (
    <div style={{ maxWidth: "100%", overflowX: "hidden" }}>
      <Row style={{ marginBottom: 10 }}>
        <Button
          type="text"
          icon={<ArrowLeftOutlined style={{ fontSize: 18 }} />}
          onClick={() => navigate(-1)}
          data-testid="attendance-back-button"
        />
      </Row>
      <Tabs
        defaultActiveKey={activeTab}
        type="card"
        size={screens.md ? "medium" : "small"}
        style={{ marginBottom: 32 }}
        tabBarGutter={screens.md ? undefined : 8}
        items={filteredMenuData}
      />
    </div>
  );
};

export default AttendanceTabs;
